import type { Dispatch } from 'redux';
import type { QuizzesState, QuizzesAction } from '@/redux/quizzes/types';
import type { GameQuestion } from '@/utils/quizQueue';

export enum Actions {
  SetQuizzesData = 'SetQuizzesData',
  SetQuizzesDataFail = 'SetQuizzesDataFail',
  SetQuizQueue = 'SetQuizQueue',
  SetQuizQueueFail = 'SetQuizQueueFail'
}

export const setQuizzesData =
  (data: Partial<QuizzesState>) => (dispatch: Dispatch<QuizzesAction>) => {
    try {
      dispatch({ type: Actions.SetQuizzesData, data });
    } catch (error) {
      dispatch({ type: Actions.SetQuizzesDataFail, error });
    }
  };

export const setQuizQueue =
  (queue: GameQuestion[]) => (dispatch: Dispatch<QuizzesAction>) => {
    try {
      dispatch({ type: Actions.SetQuizQueue, queue });
    } catch (error) {
      dispatch({ type: Actions.SetQuizQueueFail, error });
    }
  };
